<mat-form-field [appearance]="appearance" class="form-control-container" [floatLabel]="floatLabel">
  <mat-label>{{ label | translate }}</mat-label>
  <mat-icon *ngIf="prefixIcon" matPrefix width="24px" height="24px">{{ prefixIcon }}</mat-icon>
  <mat-icon *ngIf="suffixIcon" matSuffix width="24px" height="24px">{{ suffixIcon }}</mat-icon>
  <button
    mat-icon-button
    class="mat-icon-button"
    *ngIf="clearable"
    color="primary"
    matSuffix
    (click)="control.patchValue('')"
  >
    <mat-icon>clear</mat-icon>
  </button>

  <input class="input" matInput [formControl]="control" [matAutocomplete]="auto" [placeholder]="placeholder" />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)">
    <mat-option *ngFor="let option of options$ | async" [value]="option">
      {{ displayFn(option) }}
    </mat-option>
  </mat-autocomplete>

  <mat-hint>{{ hint | translate }}</mat-hint>
  <mat-error>
    <wai-form-error [formField]="control"></wai-form-error>
  </mat-error>
  <div matSuffix class="tooltip-container" *ngIf="tooltip">
    <mat-icon class="icon" aria-label="Tooltip">error_outline</mat-icon>
    <div class="tooltip">{{ tooltip }}</div>
  </div>
</mat-form-field>
